import {
  BrightnessAuto,
  Euro,
  Factory,
  PieChart,
  Settings,
  Store,
  Storefront,
  SupportAgent,
  Warehouse,
} from '@mui/icons-material';
import React from 'react';

import { getRoutePathname } from '#app/Handler/RouteHandler';
import { OrderClientState } from '#app/typings/orderClient';

type MenuChild = {
  id: string;
  label: string;
  params?: Record<string, any>;
};

type MenuGroup = {
  label: string;
  icon: React.ReactElement;
  children: MenuChild[];
};

const menuHandler: MenuGroup[] = [
  {
    label: 'Achat',
    icon: <Factory />,
    children: [
      { id: 'buy_product_list', label: 'Articles' },
      { id: 'buy_product_manage_weight_list', label: 'Articles entrepot' },
      { id: 'buy_purveyor_list', label: 'Fournisseurs' },
      { id: 'buy_order_purveyor_list', label: 'Commandes fournisseur' },
    ],
  },
  {
    label: 'Vente',
    icon: <Storefront />,
    children: [
      { id: 'sale_client_list', label: 'Clients' },
      { id: 'sale_promo_list', label: 'Codes promo' },
      {
        id: 'sale_order_client_list',
        label: 'Commandes Client',
        params: { orderClientState: '' },
      },
      {
        id: 'sale_order_client_list',
        label: 'Commandes Terminées',
        params: { orderClientState: OrderClientState.COMPLETED },
      },
      {
        id: 'sale_order_client_list',
        label: 'Commandes En Transit',
        params: { orderClientState: OrderClientState.IN_TRANSIT },
      },
      {
        id: 'sale_order_client_list',
        label: 'Commandes Confirmées',
        params: { orderClientState: OrderClientState.CONFIRMED },
      },
      {
        id: 'sale_order_client_list',
        label: 'Commandes En Litige',
        params: { orderClientState: OrderClientState.DISPUTED },
      },
      {
        id: 'sale_order_client_list',
        label: 'Commandes En Préparation',
        params: { orderClientState: OrderClientState.IN_PREPARATION },
      },
    ],
  },
  {
    label: 'Gestion des stocks',
    icon: <Warehouse />,
    children: [
      { id: 'inventory_management_deposit_list', label: 'Dépôts' },
      { id: 'inventory_deposit_picking', label: 'Depôt Picking' },
      { id: 'inventory_management_inventory_list', label: 'Inventaires' },
      { id: 'inventory_management_valorisation_stock_list', label: 'Valorisation des stocks' },
      { id: 'inventory_management_receipt_order_purveyor_list', label: 'Réceptions fournisseur' },
      { id: 'inventory_management_preparer_manager', label: 'Manager préparateur' },
      { id: 'inventory_management_preparer', label: 'Préparation commande' },
      { id: 'inventory_management_return_order', label: 'Retour commande' },
      { id: 'inventory_management_movement_list', label: 'Mouvements' },
      { id: 'inventory_management_movement_stock', label: 'Mouvements Stock' },
    ],
  },
  {
    label: 'Service client',
    icon: <SupportAgent />,
    children: [{ id: 'client_service_order_client_litige_list', label: 'Litiges Client' }],
  },
  {
    label: 'Comptabilité',
    icon: <Euro />,
    children: [
      { id: 'billing_refund_list', label: 'Remboursements Client' },
      { id: 'billing_reshipment_list', label: 'Réexpéditions Client' },
      { id: 'accounting_shop_payment', label: 'Encaissements boutique' },
    ],
  },
  {
    label: 'Gestion Boutique',
    icon: <Store />,
    children: [
      { id: 'shop_management_shop_list', label: 'Boutiques' },
      { id: 'shop_management_shop_closing_list', label: 'Fermetures caisse' },
      { id: 'shop_management_shop_region_list', label: 'Régions' },
      { id: 'shop_management_shop_list_reappro', label: 'Réapprovisionnement' },
    ],
  },
  {
    label: 'Paramétrage',
    icon: <Settings />,
    children: [
      { id: 'setting_mark_list', label: 'Marques' },
      { id: 'setting_product_type_list', label: "Types d'article" },
      { id: 'setting_galenic_list', label: 'Galéniques' },
      { id: 'setting_sector_list', label: 'Secteurs' },
      { id: 'setting_pack_size_list', label: 'Conditionnement' },
      { id: 'setting_flavor_list', label: 'Parfums / Couleurs' },
      { id: 'setting_purveyor_type_list', label: 'Types de fournisseur' },
      { id: 'setting_payment_terms_list', label: 'Conditions de paiement' },
      { id: 'setting_family_list', label: 'Familles' },
      { id: 'setting_subfamily_list', label: 'Sous-familles' },
      { id: 'setting_printer_list', label: 'Imprimantes' },
      { id: 'setting_label_printer_list', label: 'Imprimantes à étiquette' },
      { id: 'setting_tva_list', label: 'TVA' },
      { id: 'setting_tva_country_list', label: 'TVA par pays' },
    ],
  },
  {
    label: 'Administrateur',
    icon: <BrightnessAuto />,
    children: [
      { id: 'administrator_user_list', label: 'Utilisateurs' },
      { id: 'administrator_log_sylius_list', label: 'Log - Sylius' },
      { id: 'administrator_log_printer_list', label: 'Log - Imprimante' },
      { id: 'administrator_log_carrier_list', label: 'Log - Transporteur' },
    ],
  },
  {
    label: 'Statistiques',
    icon: <PieChart />,
    children: [
      { id: 'statistic_preparations', label: 'Statistiques préparation' },
      { id: 'statistic_sale_payment', label: 'Encaissements commandes' },
      { id: 'statistic_trades', label: 'Statistiques commerciales' },
      { id: 'statistic_trades_retail', label: 'Statistiques retail' },
      { id: 'statistic_sale_order_reports', label: 'Rapports de commandes' },
      { id: 'statistic_marks', label: 'Statistiques marques' },
      { id: 'statistic_buy_ca', label: 'CA fournisseur' },
      { id: 'statistic_buy_portfolio_details', label: 'Portefeuille fournisseur' },
      { id: 'statistic_sales_month', label: 'Stats vente mensuelle' },
      { id: 'statistic_sales_last_12_months', label: 'Ventes des 12 dernièrs mois' },
      { id: 'statistic_orders', label: 'Stats factures' },
    ],
  },
];

type Menu = {
  label: string;
  icon: React.ReactNode;
  children: {
    label: string;
    path: string;
  }[];
};

export const getMenu = (): Menu[] =>
  menuHandler
    .map(({ label, icon, children }) => {
      const validChildren = children
        .map(({ label, id, params }) => {
          const path = getRoutePathname(id, params);
          return path === '/' ? null : { label, path };
        })
        .filter(Boolean);

      return validChildren.length ? { label, icon, children: validChildren } : null;
    })
    .filter(Boolean) as Menu[];
